<svg:rect>
</svg:rect>